const version = "2.9.7";

export { version };
//# sourceMappingURL=version.mjs.map
